var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_vm._t("default"),_c('b-loading',{attrs:{"is-full-page":false,"active":_vm.isPending,"can-cancel":true},on:{"update:active":function($event){_vm.isPending=$event}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }